import React, { useState } from 'react'
import styles from './visualization-dropdown/Dropdown.module.scss'
import TickerDropdown from './ui/tickerDropdown/TickerDropdown'
import { useGeneral } from '../context/general'

export default function NewProjectSearchBar({textFieldProps, open, handleClose, divider}) {
    const [ticker, setTicker] = useState(null)
    const [loading, setLoading] = useState(false)
    const { handleCreateProjectAndOpen,setprojectTickerData } = useGeneral()

    const handleTicker =  async (ticker, nowcasting=false)  => {
        
        setTicker(ticker)
        setLoading(true)
        handleClose()
        await handleCreateProjectAndOpen(ticker)
        setLoading(false)
        setTicker('')
    }


    const renderOption = (params, option) => (
        <li {...params}>
            <div className={`${styles['option']}`}>
                <div>{option.value}</div>
                <div>{option.name}</div>
            </div>
        </li>
    )

    const handleChange = (newValue) =>{
        setprojectTickerData(newValue)
        handleTicker(newValue?.value,newValue?.nowcasting)
    }

    return (
        <TickerDropdown 
            textFieldProps={textFieldProps} 
            loading={loading} 
            handleChange={handleChange} 
            renderOption={renderOption}
            value={ticker}
            open={open}
            onClose={handleClose}
            divider={divider}
            elevation={10}
        />
    )
}